/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

export const language = createSlice({
  name: 'language',
  initialState: {
    value: {
      language: '',
    },
  },
  reducers: {
    setLanguage: (state, action) => {
      state.value.language = action.payload;
    },
    resetLanguage:  (state, action) => {
      state.value.language = '';
    },
  }
});

export const {
    setLanguage, resetLanguage
} = language.actions;

export default language.reducer;
